import { getTrainingKits } from '@/api/tutordata'
const trainingKit = {
  state: {
    icons: [
      { icon: 'error', name: 'Important Notes' },
      { icon: 'clear', name: 'Restrictions' },
      { icon: 'date_range', name: 'Class Table' },
      { icon: 'attach_money', name: 'Salary' },
      { icon: 'error', name: 'Credit System and Salary Increase' },
      { icon: 'error', name: 'Restrictions' },
      { icon: 'error', name: 'QQ' },
      { icon: 'filter_list', name: 'Aclassroom' },
      { icon: 'error', name: 'ClassIN' },
      { icon: 'dehaze', name: 'CS Assistance' },
      {
        icon: 'dehaze',
        name: 'How to navigate the tutor page? (Process Training Video)'
      },
      { icon: 'dehaze', name: 'Tips and Sample Video for demo class' },
      { icon: 'dehaze', name: 'Process Guide and Tips for New Tutors' },
      { icon: 'dehaze', name: 'Get Your FREE Acadsoc Background Tarpaulin' },
      { icon: 'dehaze', name: 'Teaching Note' },
      { icon: 'view_comfy', name: 'Acadsoc Teaching Standards' },
      { icon: 'description', name: 'Beginning Guide to Teaching ESL' },
      { icon: 'videocam', name: 'Teaching Method for a Free Talk Lesson' },
      { icon: 'videocam', name: 'Teaching Method for a Trial Lesson' },
      { icon: 'videocam', name: 'Sample Lesson - Video' },
      {
        icon: 'description',
        name: 'Useful Words/Phrases When Writing Remarks/Comments'
      },
      { icon: 'attach_file', name: 'Accent Training' },
      {
        icon: 'attach_file',
        name: 'American Accent Training (Self-training References)'
      },
      {
        icon: 'video_library',
        name: 'American Accent Training (Audio Instruction)'
      },
      {
        icon: 'description',
        name: 'troduction to Acadsoc Tutor Academy (ATA)'
      },
      { icon: 'video_library', name: 'Newbie Orientation' },
      { icon: 'description', name: 'Class Management' },
      { icon: 'video_library', name: 'Acadsoc Classroom Chinese' }
    ],
    items: []
  },
  mutations: {
    SET_TRAININGKITS: (state, kits) => {
      state.items = kits
    }
  },
  actions: {
    GetTrainingKits ({ commit }) {
      return new Promise((resolve, reject) => {
        if (
          !!this.state.trainingKit.items &&
          this.state.trainingKit.items.length > 0
        ) {
          resolve(this.state.trainingKit.items)
        } else {
          getTrainingKits()
            .then(res => {
              if (res.data.ErrorCode === 0) {
                let index = 0
                let isShowTest = false
                let kits = res.data.Body.map(t => {
                  isShowTest = false
                  return {
                    key: t.CategoryName,
                    item: t.Items.map(e => {
                      let iconTF = this.state.trainingKit.icons.find(
                        t => t.name === e.Name
                      )
                      if (t.CategoryName === 'Training Test') {
                        isShowTest = true
                        iconTF = {
                          icon: 'description'
                        }
                      }
                      return {
                        icon: (iconTF && iconTF.icon) || e.Icon || '',
                        title: e.Name,
                        isPass: e.IsPass,
                        no: e.ID,
                        score: e.TestScore,
                        usedTime: e.TestTime,
                        ShowTest: isShowTest
                      }
                    })
                  }
                })
                commit('SET_TRAININGKITS', kits)
                resolve(kits)
              } else {
                resolve([])
              }
            })
            .catch(error => {
              reject(error)
            })
        }
      })
    }
  }
}

export default trainingKit
